import styled from "styled-components";
import fontSize from "../../theme/fonts/FontTheme";

const H2 = styled.h2`
  font-size: ${fontSize.xl};
`;

export default H2;
